export const removeBioOrganic = (title: string) => title.replace(/, (bio|organic)$/i, '')
